var React = require('react');

function CopyIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","stroke":"#000","strokeWidth":"2","d":"M7 23h16V7H7v16zM17 4V1h-3M1 14v3h3m-3-5V6v6zM4 1H1v3m5-3h6-6z"}));
}

CopyIcon.defaultProps = {"aria-label":"Clone","viewBox":"0 0 24 24"};

module.exports = CopyIcon;

CopyIcon.default = CopyIcon;
